export function mapTimeResponse(time: number[]): string {
  const minute = time[1] < 10 ? `0${time[1]}` : time[1]

  return `${time[0]}:${minute}`
}
